import { CircleX } from 'lucide-react';
import type { FailedStepProps } from '../types';
import { BackToLoginLink, InfoBox, InfoBoxTitle, InfoBoxList } from '../shared';

/**
 * 重置密码失败步骤页面
 */
export function ResetFailedStep({ onStepChange }: FailedStepProps) {
  const reasons = [
    "You haven't clicked the latest password reset link yet",
    'The password reset link has expired (valid for 1h)',
    'Network issues',
  ];

  return (
    <div className="flex w-full flex-col gap-[24px]">
      {/* 标题区域 */}
      <div className="flex flex-col items-center gap-[8px]">
        <div className="flex items-center gap-[8px]">
          <CircleX className="h-[28px] w-[28px] text-[#ef4444]" />
          <h2 className="text-[20px] font-semibold leading-[1.2] tracking-[-0.4px] text-[#ef4444]">
            Password reset failed
          </h2>
        </div>
        <p className="text-center text-[14px] font-normal leading-[1.5] tracking-[0.07px] text-[#525252]">
          Sorry, we were unable to reset your password.
        </p>
      </div>

      {/* 可能原因 */}
      <InfoBox>
        <InfoBoxTitle>Possible reasons:</InfoBoxTitle>
        <InfoBoxList items={reasons} />
      </InfoBox>

      {/* 返回登录按钮 */}
      <BackToLoginLink variant="icon" onClick={() => onStepChange?.('login')} />
    </div>
  );
}

export default ResetFailedStep;
